export default __webpack_public_path__ + "static/java-59895221a17f682d6984418db31a38b3.webp";